import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/* 🔔 TOAST */
const Toast = ({ msg }) => (
  <div className="fixed top-6 right-6 bg-emerald-500 text-white px-4 py-3 rounded-xl shadow-lg z-50">
    {msg}
  </div>
);

/* ================= MOCK WORKERS ================= */
const WORKERS = [
  { id: 1, name: "Rajesh Kumar", trade: "Electrician", exp: 8, rate: 900 },
  { id: 2, name: "Suresh Patel", trade: "Electrician", exp: 6, rate: 800 },
  { id: 3, name: "Amit Sharma", trade: "Electrician", exp: 10, rate: 1200 },
  { id: 10, name: "Rajesh Kumar", trade: "Electrician", exp: 8, rate: 900 },
  

  { id: 4, name: "Ravi Yadav", trade: "Plumber", exp: 7, rate: 700 },
  { id: 5, name: "Sunil Gupta", trade: "Plumber", exp: 5, rate: 600 },
  { id: 6, name: "Deepak Singh", trade: "Plumber", exp: 9, rate: 900 },
  { id: 11, name: "Rajesh Kumar", trade: "Plumber", exp: 8, rate: 900 },

  { id: 7, name: "Vikas Verma", trade: "Driver", exp: 4, rate: 500 },
  { id: 8, name: "Ankit Kumar", trade: "Driver", exp: 6, rate: 650 },
  { id: 9, name: "Rohit Mehta", trade: "Driver", exp: 8, rate: 750 },
  { id: 12, name: "Rajesh Kumar", trade: "Driver", exp: 8, rate: 900 },
];

/* ================= MATCH SCORE ================= */
function getMatchScore(worker, job) {
  let score = 0;

  if (worker.trade === job.trade) score += 50;
  score += Math.min(worker.exp * 4, 30);

  if (job.minPay && worker.rate >= job.minPay) score += 10;

  if (
    job.description &&
    job.description.toLowerCase().includes(worker.trade.toLowerCase())
  ) {
    score += 10;
  }

  return Math.min(score, 100);
}

export default function PostJob() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    trade: "All",
    location: "",
    minPay: "",
    maxPay: "",
    duration: "",
    description: "",
  });

  const [posted, setPosted] = useState(false);
  const [toast, setToast] = useState("");

  /* 🔥 LOAD FROM LOCAL */
  useEffect(() => {
    const saved = localStorage.getItem("jobData");
    if (saved) {
      setForm(JSON.parse(saved));
      setPosted(true);
    }
  }, []);

  function onInputChange(key, val) {
    setForm((s) => ({ ...s, [key]: val }));
  }

  /* ================= POST ================= */
 const handlePostJob = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      "https://digital-worker-exchange.onrender.com/api/jobs",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: `${form.trade} Needed`,
          trade: form.trade,
          location: form.location,
          minPay: Number(form.minPay),
          maxPay: Number(form.maxPay),
          duration: form.duration,
          description: form.description,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      alert(data.message);
      return;
    }

    setPosted(true);

    setToast("🚀 Job Posted Successfully!");

    setTimeout(() => {
      setToast("");
    }, 3000);

  } catch (error) {
    console.error(error);
    alert("Failed to post job");
  }
};
  /* ================= FILTER + SCORE ================= */
 const recommendedWorkers = useMemo(() => {
  return WORKERS
    .filter((worker) => {
      if (form.trade === "All") {
        return true;
      }

      return worker.trade === form.trade;
    })
    .map((worker) => ({
      ...worker,
      score: getMatchScore(worker, form),
    }))
    .sort((a, b) => b.score - a.score);
}, [form]);

const bestWorker = recommendedWorkers[0];

  /* 🔥 DYNAMIC TITLE (RESTORED FEATURE) */
  const dynamicTitle = `${form.trade} needed for ${
    form.description || "work"
  }`;

  /* 🔥 SAME REDIRECT AS OLD HIRE FLOW */
  const handleRedirect = (workerId) => {
    navigate(`/hire/${workerId}`); // 👈 SAME AS YOUR OLD FLOW
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-emerald-50 pt-24 px-6 pb-16">

      {toast && <Toast msg={toast} />}

      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8">

        {/* ================= LEFT (UNCHANGED + RESTORED FEATURE) ================= */}
        <div className="lg:col-span-4">
          <div className="bg-white/80 backdrop-blur-xl border shadow-xl rounded-3xl p-6 sticky top-24">

            <h2 className="text-2xl font-bold mb-2">Post a Job</h2>

            {/* 🔥 RESTORED DYNAMIC LINE */}
            <p className="text-sm text-blue-600 mb-4">
              {dynamicTitle}
            </p>

            <Select label="Trade" value={form.trade} onChange={(v)=>onInputChange("trade",v)} />
            <Input label="Location" value={form.location} onChange={(v)=>onInputChange("location",v)} />

            <div className="grid grid-cols-2 gap-3">
              <Input label="Min Pay" type="number" value={form.minPay} onChange={(v)=>onInputChange("minPay",v)} />
              <Input label="Max Pay" type="number" value={form.maxPay} onChange={(v)=>onInputChange("maxPay",v)} />
            </div>

            <Input label="Duration" value={form.duration} onChange={(v)=>onInputChange("duration",v)} />

            <textarea
              className="w-full mt-4 p-3 rounded-xl border"
              placeholder="Describe the job..."
              value={form.description}
              onChange={(e)=>onInputChange("description", e.target.value)}
            />

            <button
              onClick={handlePostJob}
              className="w-full mt-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-emerald-500 text-white"
            >
              Post Job
            </button>

          </div>
        </div>

        {/* ================= RIGHT (UNCHANGED FEATURES + REDIRECT FIX) ================= */}
        <div className="lg:col-span-8">

          <h2 className="text-2xl font-bold mb-6">
            {posted ? "AI Recommended Workers" : "Available Workers"}
          </h2>

          {posted && bestWorker && (
            <div className="mb-6 p-5 rounded-2xl bg-gradient-to-r from-emerald-500 to-blue-600 text-white shadow-lg">
              <h3 className="font-bold text-lg">
                ⚡ Auto Hire Recommendation
              </h3>

              <div className="mt-3 flex justify-between items-center">
                <span>
                  {bestWorker.name} ({bestWorker.score}% match)
                </span>

                <button
                  onClick={() => handleRedirect(bestWorker.id)}
                  className="bg-white text-black px-3 py-1 rounded-lg"
                >
                  Hire Now
                </button>
              </div>
            </div>
          )}

          <div className="grid md:grid-cols-2 gap-5">

            {recommendedWorkers.map((w, i) => (
              <div key={w.id} className="bg-white p-5 rounded-2xl shadow relative">

                {posted && i === 0 && (
                  <span className="absolute top-3 right-3 bg-yellow-400 text-xs px-2 py-1 rounded-full">
                    🏆 Best Match
                  </span>
                )}

                <h3 className="font-semibold">{w.name}</h3>

                <p className="text-sm text-gray-500">
                  {w.trade} • {w.exp} yrs
                </p>

                {posted && (
                  <p className="text-blue-600 text-sm">
                    Match: {w.score}%
                  </p>
                )}

                <div className="mt-4 flex justify-between">
                  <span className="text-emerald-600 font-bold">
                    ₹{w.rate}/day
                  </span>

                  <button
                     onClick={() => navigate(`/worker/${w.id}`)}
                    className="px-3 py-1 bg-blue-600 text-white rounded-lg"
                  >
                    View
                  </button>
                </div>

              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
}

/* INPUT */
const Input = ({ label, value, onChange, type="text" }) => (
  <div className="mt-4">
    <label className="text-sm">{label}</label>
    <input
      type={type}
      value={value}
      onChange={(e)=>onChange(e.target.value)}
      className="w-full mt-1 p-3 rounded-xl border"
    />
  </div>
);

/* SELECT */
const Select = ({ label, value, onChange }) => (
  <div className="mt-4">
    <label className="text-sm">{label}</label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full mt-1 p-3 rounded-xl border"
    >
      <option value="All">All Workers</option>
      <option value="Electrician">Electrician</option>
      <option value="Plumber">Plumber</option>
      <option value="Driver">Driver</option>
    </select>
  </div>
);